import AbacusContext from './abacus/abacus-context';
import {ApolloProvider} from 'react-apollo';
import App from './components/App/App';
import {AuthContext} from './components/auth';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import React from 'react';
import {TranslationsContext} from './components/translations';

/**
 * Basic provider wrapping. This has been externalized in order to
 * enable hot module replacement features.
 */

/* istanbul ignore next */
function Root({store, client}) {
    return (
        <ApolloProvider client={client}>
            <Provider store={store}>
                <AuthContext.Provider value={window.__AUTH__}>
                    <TranslationsContext.Provider value={window.__TRANSLATIONS__}>
                        <AbacusContext.Provider value={window.__ABACUS__}>
                            <BrowserRouter>
                                <App/>
                            </BrowserRouter>
                        </AbacusContext.Provider>
                    </TranslationsContext.Provider>
               </AuthContext.Provider>
            </Provider>
        </ApolloProvider>
    );
}

export default Root;



// WEBPACK FOOTER //
// ./src/universal/Root.js